import { signal } from "../net/signal";
import { serverBase } from "../net/config";

/**
 * چهره‌ی بازیکن — همان کلیدهای قهرمانانِ اپ (`Heroes/<key>`).
 *
 * کلید با Hello به سرور می‌رود و سرور آن را به صندلیِ ما می‌چسباند؛ بقیه — وب یا
 * موبایل — همان چهره را می‌بینند. چهره‌ی خودمان سلیقه‌ی این دستگاه است، پس در
 * localStorage می‌مانَد.
 */
export const avatars: { key: string; fa: string }[] = [
  { key: "player", fa: "خودم" },
  { key: "kalantar", fa: "کلانتر" },
  { key: "daneshmand", fa: "دانشمند" },
  { key: "gharibeh", fa: "غریبه" },
  { key: "iliati", fa: "ایلیاتی" },
  { key: "jallad", fa: "جلاد" },
  { key: "loti", fa: "لوطی" },
  { key: "luti", fa: "لوتی" },
  { key: "pahlavan", fa: "پهلوان" },
  { key: "pishkar", fa: "پیشکار" },
  { key: "qajari", fa: "قجری" },
  { key: "shahdokht", fa: "شاهدخت" },
  { key: "takkhal", fa: "تک‌خال" },
  { key: "yaghi", fa: "یاغی" },
];

const KEY = "bazivan.avatar";
const known = new Set(avatars.map((a) => a.key));

function load(): string {
  try {
    const v = localStorage.getItem(KEY);
    if (v && known.has(v)) return v;
  } catch { /* حالتِ ناشناس */ }
  return "player";
}

export const avatar = signal<string>(load());

export function setAvatar(key: string): void {
  if (!known.has(key) && !isUploaded(key)) return;
  avatar.value = key;
  try { localStorage.setItem(KEY, key); } catch { /* بی‌ذخیره هم کار می‌کند */ }
}

/**
 * عکسِ آپلودیِ خودمان؟
 *
 * فقط مسیرِ نسبیِ پوشه‌ی اسِتِ خودِ سرور پذیرفته است و نه هر نشانی‌ای. سرور
 * هم همین را می‌سازد و هم در Hello حرفِ کلاینت را درباره‌ی آواتار باور
 * نمی‌کند؛ این‌جا فقط لایه‌ی دومِ همان است، تا یک رشته‌ی دست‌کاری‌شده در
 * حافظه‌ی مرورگر نتواند مرورگرِ بقیه را به گرفتنِ تصویر از جای دیگر وادارد.
 */
export function isUploaded(key: string | undefined): boolean {
  return !!key && key.startsWith("/v1/assets/avatar-") && !key.includes("..");
}

/** تصویرِ چهره برای هر کلیدی که سرور بدهد؛ ناشناس → پیش‌فرض.
 *
 * عکسِ آپلودی از خودِ سرور می‌آید و نه از کنارِ صفحه: در حالتِ آزمایشی
 * (`?server=`) سایت و سرور دو ریشه‌ی جدا دارند و مسیرِ نسبی به هیچ‌جا نمی‌رسید.
 */
export function avatarSrc(key: string | undefined): string {
  if (isUploaded(key)) return serverBase + key;
  return `/art/avatars/${key && known.has(key) ? key : "player"}.webp`;
}
